import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getLocalTranslation } from '../utils/i18nKit';
export var allEUCountryMap = {
  AT: {
    value: 'AT',
    label: 'Austria'
  },
  BE: {
    value: 'BE',
    label: 'Belgium'
  },
  BG: {
    value: 'BG',
    label: 'Bulgaria'
  },
  HR: {
    value: 'HR',
    label: 'Croatia'
  },
  CY: {
    value: 'CY',
    label: 'Cyprus'
  },
  CZ: {
    value: 'CZ',
    label: 'Czech Republic'
  },
  DK: {
    value: 'DK',
    label: 'Denmark'
  },
  EE: {
    value: 'EE',
    label: 'Estonia'
  },
  FI: {
    value: 'FI',
    label: 'Finland'
  },
  FR: {
    value: 'FR',
    label: 'France'
  },
  DE: {
    value: 'DE',
    label: 'Germany'
  },
  GR: {
    value: 'GR',
    label: 'Greece'
  },
  HU: {
    value: 'HU',
    label: 'Hungary'
  },
  IS: {
    value: 'IS',
    label: 'Iceland'
  },
  IE: {
    value: 'IE',
    label: 'Ireland'
  },
  IT: {
    value: 'IT',
    label: 'Italy'
  },
  LV: {
    value: 'LV',
    label: 'Latvia'
  },
  LI: {
    value: 'LI',
    label: 'Liechtenstein'
  },
  LT: {
    value: 'LT',
    label: 'Lithuania'
  },
  LU: {
    value: 'LU',
    label: 'Luxembourg'
  },
  MT: {
    value: 'MT',
    label: 'Malta'
  },
  NL: {
    value: 'NL',
    label: 'Netherlands'
  },
  NO: {
    value: 'NO',
    label: 'Norway'
  },
  PL: {
    value: 'PL',
    label: 'Poland'
  },
  PT: {
    value: 'PT',
    label: 'Portugal'
  },
  RO: {
    value: 'RO',
    label: 'Romania'
  },
  SK: {
    value: 'SK',
    label: 'Slovakia'
  },
  SI: {
    value: 'SI',
    label: 'Slovenia'
  },
  ES: {
    value: 'ES',
    label: 'Spain'
  },
  SE: {
    value: 'SE',
    label: 'Sweden'
  }
};
export var allEUCountryMapList = Object.values(allEUCountryMap);
export var allCountryInfoMap = _objectSpread(_objectSpread({}, allEUCountryMap), {}, {
  GB: {
    value: 'GB',
    label: 'United Kingdom'
  },
  US: {
    value: 'US',
    label: 'United States'
  }
});
export var allCountryInfoMapList = Object.values(allCountryInfoMap);
export var supportTranslationCountryList = [{
  value: 'GB',
  label: 'English (United Kingdom)'
}, {
  value: 'US',
  label: 'English (United States)'
}, {
  value: 'AT',
  label: 'German (Austria)'
}, {
  value: 'BE',
  label: 'Dutch (Belgium)'
}, {
  value: 'BG',
  label: 'Bulgarian'
}, {
  value: 'HR',
  label: 'Croatian'
}, {
  value: 'CY',
  label: 'Greek (Cyprus)'
}, {
  value: 'CZ',
  label: 'Czech'
}, {
  value: 'DK',
  label: 'Danish'
}, {
  value: 'EE',
  label: 'Estonian'
}, {
  value: 'FI',
  label: 'Finnish'
}, {
  value: 'FR',
  label: 'French'
}, {
  value: 'DE',
  label: 'German (Germany)'
}, {
  value: 'GR',
  label: 'Greek'
}, {
  value: 'HU',
  label: 'Hungarian'
}, {
  value: 'IE',
  label: 'Ireland'
}, {
  value: 'IT',
  label: 'Italian'
}, {
  value: 'LV',
  label: 'Latvian'
}, {
  value: 'LT',
  label: 'Lithuanian'
}, {
  value: 'LU',
  label: 'French (Luxembourg)'
}, {
  value: 'MT',
  label: 'Maltese'
}, {
  value: 'NL',
  label: 'Dutch (Netherlands)'
}, {
  value: 'PL',
  label: 'Polish'
}, {
  value: 'PT',
  label: 'Portuguese'
}, {
  value: 'RO',
  label: 'Romanian'
}, {
  value: 'SK',
  label: 'Slovak'
}, {
  value: 'SL',
  label: 'Slovenian'
}, {
  value: 'ES',
  label: 'Spanish'
}, {
  value: 'SE',
  label: 'Swedish'
}];
export var getSupportTranslationCountryList = function getSupportTranslationCountryList() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return [{
    value: 'GB',
    label: $t('kit:country.lang_en_gb')
  }, {
    value: 'US',
    label: $t('kit:country.lang_en_us')
  }, {
    value: 'AT',
    label: $t('kit:country.lang_de_at')
  }, {
    value: 'BE',
    label: $t('kit:country.lang_nl_be')
  }, {
    value: 'BG',
    label: $t('kit:country.lang_bg')
  }, {
    value: 'HR',
    label: $t('kit:country.lang_hr')
  }, {
    value: 'CY',
    label: $t('kit:country.lang_el_cy')
  }, {
    value: 'CZ',
    label: $t('kit:country.lang_cs')
  }, {
    value: 'DK',
    label: $t('kit:country.lang_da')
  }, {
    value: 'EE',
    label: $t('kit:country.lang_et')
  }, {
    value: 'FI',
    label: $t('kit:country.lang_fi')
  }, {
    value: 'FR',
    label: $t('kit:country.lang_fr')
  }, {
    value: 'DE',
    label: $t('kit:country.lang_de_de')
  }, {
    value: 'GR',
    label: $t('kit:country.lang_el')
  }, {
    value: 'HU',
    label: $t('kit:country.lang_hu')
  }, {
    value: 'IT',
    label: $t('kit:country.lang_it')
  }, {
    value: 'LV',
    label: $t('kit:country.lang_lv')
  }, {
    value: 'LT',
    label: $t('kit:country.lang_lt')
  }, {
    value: 'LU',
    label: $t('kit:country.lang_fr_lu')
  }, {
    value: 'MT',
    label: $t('kit:country.lang_mt')
  }, {
    value: 'NL',
    label: $t('kit:country.lang_nl_nl')
  }, {
    value: 'PL',
    label: $t('kit:country.lang_pl')
  }, {
    value: 'PT',
    label: $t('kit:country.lang_pt')
  }, {
    value: 'RO',
    label: $t('kit:country.lang_ro')
  }, {
    value: 'SK',
    label: $t('kit:country.lang_sk')
  }, {
    value: 'SL',
    label: $t('kit:country.lang_sl')
  }, {
    value: 'ES',
    label: $t('kit:country.lang_es')
  }, {
    value: 'SE',
    label: $t('kit:country.lang_sv')
  }];
};
export var supportTranslationEUCountryList = supportTranslationCountryList.filter(function (item) {
  return !['GB', 'US'].includes(item.value);
});
export var supportTranslationEUAndUKCountryList = supportTranslationCountryList.filter(function (item) {
  return !['US'].includes(item.value);
});
export var supportTranslationCountryConvertMap = {
  GB: {
    locale: 'en',
    joveUseLocale: 'en',
    stripeLocale: 'en',
    name: 'United Kingdom',
    platformName: 'English',
    chineseName: '英国',
    countryCode: 'GB'
  },
  CN: {
    locale: 'zh-Hans',
    joveUseLocale: 'zh-Hans',
    stripeLocale: 'zh',
    name: 'China',
    platformName: 'Chinese (simplified)',
    chineseName: '中国',
    countryCode: 'CN'
  },
  AT: {
    locale: 'de-AT',
    joveUseLocale: 'de-AT',
    supportLocales: ['de'],
    stripeLocale: 'de',
    name: 'Austria',
    platformName: 'German (Austria)',
    chineseName: '奥地利',
    countryCode: 'AT'
  },
  BE: {
    locale: 'nl-BE',
    joveUseLocale: 'nl-BE',
    supportLocales: ['nl', 'fr', 'de'],
    stripeLocale: 'nl',
    name: 'Belgium',
    platformName: 'Dutch (Belgium)',
    chineseName: '比利时',
    countryCode: 'BE'
  },
  BG: {
    locale: 'bg',
    joveUseLocale: 'bg',
    supportLocales: ['bg'],
    stripeLocale: 'bg',
    name: 'Bulgaria',
    platformName: 'Bulgarian',
    chineseName: '保加利亚',
    countryCode: 'BG'
  },
  HR: {
    locale: 'hr',
    joveUseLocale: 'hr',
    supportLocales: ['hr'],
    stripeLocale: 'hr',
    name: 'Croatia',
    platformName: 'Croatian',
    chineseName: '克罗地亚',
    countryCode: 'HR'
  },
  CY: {
    locale: 'el',
    joveUseLocale: 'el',
    supportLocales: ['el', 'tr'],
    stripeLocale: 'el',
    name: 'Cyprus',
    platformName: 'Cyprus',
    chineseName: '塞浦路斯',
    countryCode: 'CY'
  },
  CZ: {
    locale: 'cs',
    joveUseLocale: 'cs',
    supportLocales: ['cs'],
    stripeLocale: 'cs',
    name: 'Czech Republic',
    platformName: 'Czech',
    chineseName: '捷克共和国',
    countryCode: 'CZ'
  },
  DK: {
    locale: 'da',
    joveUseLocale: 'da',
    supportLocales: ['da'],
    stripeLocale: 'da',
    name: 'Denmark',
    platformName: 'Danish',
    chineseName: '丹麦',
    countryCode: 'DK'
  },
  EE: {
    locale: 'et',
    joveUseLocale: 'et',
    supportLocales: ['et'],
    stripeLocale: 'et',
    name: 'Estonia',
    platformName: 'Estonian',
    chineseName: '爱沙尼亚',
    countryCode: 'EE'
  },
  FI: {
    locale: 'fi',
    joveUseLocale: 'fi',
    supportLocales: ['fi', 'sv'],
    stripeLocale: 'fi',
    name: 'Finland',
    platformName: 'Finnish',
    chineseName: '芬兰',
    countryCode: 'FI'
  },
  FR: {
    locale: 'fr',
    joveUseLocale: 'fr',
    supportLocales: ['fr'],
    stripeLocale: 'fr',
    name: 'France',
    platformName: 'French',
    chineseName: '法国',
    countryCode: 'FR'
  },
  DE: {
    locale: 'de',
    joveUseLocale: 'de',
    supportLocales: ['de'],
    stripeLocale: 'de',
    name: 'Germany',
    platformName: 'German',
    chineseName: '德国',
    countryCode: 'DE'
  },
  GR: {
    locale: 'el',
    joveUseLocale: 'el',
    supportLocales: ['el'],
    stripeLocale: 'el',
    name: 'Greece',
    platformName: 'Greek',
    chineseName: '希腊',
    countryCode: 'GR'
  },
  HU: {
    locale: 'hu',
    joveUseLocale: 'hu',
    supportLocales: ['hu'],
    stripeLocale: 'hu',
    name: 'Hungary',
    platformName: 'Hungarian',
    chineseName: '匈牙利',
    countryCode: 'HU'
  },
  IE: {
    locale: 'ga',
    joveUseLocale: 'ga',
    supportLocales: ['ga', 'en'],
    stripeLocale: 'ga',
    name: 'Ireland',
    platformName: 'Irish',
    chineseName: '爱尔兰',
    countryCode: 'IE'
  },
  IT: {
    locale: 'it',
    joveUseLocale: 'it',
    supportLocales: ['it'],
    stripeLocale: 'it',
    name: 'Italy',
    platformName: 'Italian (Italy)',
    chineseName: '意大利',
    countryCode: 'IT'
  },
  LV: {
    locale: 'lv',
    joveUseLocale: 'lv',
    supportLocales: ['lv'],
    stripeLocale: 'lv',
    name: 'Latvia',
    platformName: 'Latvian',
    chineseName: '拉脱维亚',
    countryCode: 'LV'
  },
  LT: {
    locale: 'lt',
    joveUseLocale: 'lt',
    supportLocales: ['lt'],
    stripeLocale: 'lt',
    name: 'Lithuania',
    platformName: 'Lithuanian',
    chineseName: '立陶宛',
    countryCode: 'LT'
  },
  LU: {
    locale: 'lb',
    joveUseLocale: 'lb',
    supportLocales: ['lb', 'fr', 'de'],
    stripeLocale: 'lb',
    name: 'Luxembourg',
    platformName: 'Luxembourgish',
    chineseName: '卢森堡',
    countryCode: 'LU'
  },
  MT: {
    locale: 'mt',
    joveUseLocale: 'mt',
    supportLocales: ['mt', 'en'],
    stripeLocale: 'mt',
    name: 'Malta',
    platformName: 'Maltese',
    chineseName: '马耳他',
    countryCode: 'MT'
  },
  NL: {
    locale: 'nl-NL',
    joveUseLocale: 'nl-NL',
    supportLocales: ['nl'],
    stripeLocale: 'nl',
    name: 'Netherlands',
    platformName: 'Dutch (Netherlands)',
    chineseName: '荷兰',
    projectLocalUseLocale: 'nl-BE',
    countryCode: 'NL'
  },
  PL: {
    locale: 'pl',
    joveUseLocale: 'pl',
    supportLocales: ['pl'],
    stripeLocale: 'pl',
    name: 'Poland',
    platformName: 'Polish',
    chineseName: '波兰',
    countryCode: 'PL'
  },
  PT: {
    locale: 'pt-PT',
    joveUseLocale: 'pt-PT',
    supportLocales: ['pt'],
    stripeLocale: 'pt',
    name: 'Portugal',
    platformName: 'Portuguese (Portugal)',
    chineseName: '葡萄牙',
    countryCode: 'PT'
  },
  RO: {
    locale: 'ro-RO',
    joveUseLocale: 'ro-RO',
    supportLocales: ['ro'],
    stripeLocale: 'ro',
    name: 'Romania',
    platformName: 'Romanian (Romania)',
    chineseName: '罗马尼亚',
    countryCode: 'RO'
  },
  SK: {
    locale: 'sk',
    joveUseLocale: 'sk',
    supportLocales: ['sk'],
    stripeLocale: 'sk',
    name: 'Slovakia',
    platformName: 'Slovak',
    chineseName: '斯洛伐克',
    countryCode: 'SK'
  },
  SL: {
    locale: 'sl',
    joveUseLocale: 'sl',
    supportLocales: ['sl'],
    stripeLocale: 'sl',
    name: 'Slovenia',
    platformName: 'Slovenian',
    chineseName: '斯洛文尼亚',
    countryCode: 'SL'
  },
  ES: {
    locale: 'es-ES',
    joveUseLocale: 'es-ES',
    supportLocales: ['es'],
    stripeLocale: 'es',
    name: 'Spain',
    platformName: 'Spanish (Spain)',
    chineseName: '西班牙',
    countryCode: 'ES'
  },
  SE: {
    locale: 'sv',
    joveUseLocale: 'sv',
    supportLocales: ['sv'],
    stripeLocale: 'sv',
    name: 'Sweden',
    platformName: 'Swedish',
    chineseName: '瑞典',
    countryCode: 'SE'
  },
  US: {
    locale: 'en-US',
    joveUseLocale: 'en-US',
    supportLocales: ['en'],
    stripeLocale: 'en',
    name: 'English (America)',
    platformName: 'English (America)',
    chineseName: '美式英语',
    countryCode: 'US'
  },
  NO: {
    locale: 'no',
    joveUseLocale: 'no',
    supportLocales: ['no'],
    stripeLocale: 'no',
    name: 'Norway',
    platformName: 'Norway',
    chineseName: '挪威',
    countryCode: 'NO'
  },
  DEFAULT: {
    locale: 'en',
    joveUseLocale: 'en',
    stripeLocale: 'en',
    name: 'United Kingdom',
    platformName: 'English',
    chineseName: '英国',
    countryCode: 'GB'
  }
};
export var getSupportTranslationCountryConvertMap = function getSupportTranslationCountryConvertMap() {
  var _getLocalTranslation2 = getLocalTranslation(),
      $t = _getLocalTranslation2.$t;

  var translationKeyMap = {
    GB: 'kit:country.united_kingdom',
    CN: 'kit:country.china',
    AT: 'kit:country.austria',
    BE: 'kit:country.belgium',
    BG: 'kit:country.bulgaria',
    HR: 'kit:country.croatia',
    CY: 'kit:country.cyprus',
    CZ: 'kit:country.czech_republic',
    DK: 'kit:country.denmark',
    EE: 'kit:country.estonia',
    FI: 'kit:country.finland',
    FR: 'kit:country.france',
    DE: 'kit:country.germany',
    GR: 'kit:country.greece',
    HU: 'kit:country.hungary',
    IE: 'kit:country.ireland',
    IT: 'kit:country.italy',
    LV: 'kit:country.latvia',
    LT: 'kit:country.lithuania',
    LU: 'kit:country.luxembourg',
    MT: 'kit:country.malta',
    NL: 'kit:country.netherlands',
    PL: 'kit:country.poland',
    PT: 'kit:country.portugal',
    RO: 'kit:country.romania',
    SK: 'kit:country.slovakia',
    SL: 'kit:country.slovenia',
    ES: 'kit:country.spain',
    SE: 'kit:country.sweden',
    US: 'kit:country.english_america',
    NO: 'kit:country.norway',
    DEFAULT: 'kit:country.united_kingdom'
  };
  return Object.fromEntries(Object.entries(supportTranslationCountryConvertMap).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        countryCode = _ref2[0],
        country = _ref2[1];

    return [countryCode, _objectSpread(_objectSpread({}, country), {}, {
      name: $t(translationKeyMap[countryCode])
    })];
  }));
};
export var getAllSupportTranslationCountryList = function getAllSupportTranslationCountryList() {
  return Object.values(supportTranslationCountryConvertMap);
};